// Product.jsx
import React from "react";
import Header from "../components/Header"; //header
import Footer from "../components/Footer"; //footer
import Dashboard from "../components/Dashboard";
import CardSlider from "../components/CardSlider";
import playground from '../assets/img/product_img/Indoor playground.png';
import trampoline from '../assets/img/product_img/Trampoline Park.png';
import interactiveGame from '../assets/img/product_img/Interactive Games.png';
import climbingwall from '../assets/img/product_img/Climbing Wall.png';
import NinjaPark from '../assets/img/product_img/Ninja Park.png';
import entrancesoftwre from '../assets/img/product_img/Entrance Software.png';
import products from "../assets/img/products.png";
import plusicon from '../assets/img/product_img/plusicon.png';
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb.jsx"
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import WhatsappButton from "../components/WhatsappButton.jsx";

const Product = () => {
  const navigate = useNavigate();

  let title = (<>Explore The GEM<br/> Product Universe</>)
  let description = (<> Global Entertainment Manufacturer bring excitement to life with innovative entertainment solutions. Designed for thrill-seekers of all ages, our creations combine fun, fitness, and technology for an unforgettable experience. 
</>)

  return (
    <div>
      <Helmet>
        <meta name="trampoline company" content="GEM is the ultimate playgrounds destination, offering
 fun, safe, and engaging spaces for all ages. Explore
 our innovative playgrounds designed for adventure!" />
      </Helmet>
      <Header />
      <Dashboard  Breadcrumb={
    <div style={{ backgroundColor: '', marginTop: '13%',marginLeft:"3%", borderRadius: '5px' }}>
      <Breadcrumb />
    </div>
  }  title={title} imageUrl={products} description={description}/>
    <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
      <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="icon-container">
              <img
                src={plusicon}
                alt="indoor playground design"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button">Get Quotation</button>
            </div>
          </Link>
      {/* <CardSlider /> */}
      <section className="product-section">
        <div >
          <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>

            <h1>Products</h1>
            <div className="icon-container">
              <img
                src={plusicon}
                alt="playground equipment catalog"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button">Get Quotation</button>
            </div>
          </Link>
        </div>

        <div className="product-container">
        

          <div className='product-row'>
            <div className="product" >
              <div onClick={() => navigate("/TrampolinePark")}  to="/trampoline" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={trampoline} alt="indoor playground" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p  style={{ cursor: 'pointer' }}>Trampoline Park
                </p>
              </div>
            </div>
            <div className="product" >
            <div onClick={() => navigate("/IndoorPlayground")}  to="/Playground" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={playground} alt="indoor playground design" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p style={{ cursor: 'pointer' }}>Indoor Playground
                </p>
              </div>
            </div>
            <div className="product" >
              <Link to="/Interactivegames" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={interactiveGame} alt="indoor playground" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Interactive Games
                </p>
              </Link>
            </div>
          </div>
          <div className='product-row'>
            <div className="product" >
              <Link to="/Climbingwall" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={climbingwall} alt="playground equipment company" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Climbing Wall
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/NinjaPark" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={NinjaPark} alt="playgrounds" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Ninja Park
                </p>
              </Link>
            </div>
            <div className="product" >
            <Link to="/EntranceSoftware" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={entrancesoftwre} alt="kids playground" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Entrance Software</p>
              </Link>
            </div>
          </div>
        </div>

      </section>

      <Footer />
    </div>
  );
};

export default Product;





